import {useEffect, useRef} from "react";

import {hitUserSegmentLocationEntry} from "@pg-mono/google-tag-manager";

interface IProps {
    enabled: boolean;
    regions: Parameters<typeof hitUserSegmentLocationEntry>[0];
}

export function useHitUserSegmentLocationEntryOnce(props: IProps) {
    const {enabled, regions} = props;
    const hasHitLocationEntrySegments = useRef(false);

    useEffect(() => {
        if (hasHitLocationEntrySegments.current || !enabled) {
            return;
        }

        hitUserSegmentLocationEntry(regions);
        hasHitLocationEntrySegments.current = true;
    }, [enabled, regions]);
}
import {useEffect, useRef} from "react";

import {hitUserSegmentLocationEntry} from "@pg-mono/google-tag-manager";

interface IProps {
    enabled: boolean;
    regions: Parameters<typeof hitUserSegmentLocationEntry>[0];
}

export function useHitUserSegmentLocationEntryOnce(props: IProps) {
    const {enabled, regions} = props;
    const hasHitLocationEntrySegments = useRef(false);

    useEffect(() => {
        if (hasHitLocationEntrySegments.current || !enabled) {
            return;
        }

        hitUserSegmentLocationEntry(regions);
        hasHitLocationEntrySegments.current = true;
    }, [enabled, regions]);
}
